import { PREVIOUS_URL_KEY } from 'links/login/constants'
import { useRef } from 'react'
import { getFromSessionStorage } from 'utils/webStorage/sessionStorage'

export const usePreviousUrl = () => {
	const previousUrlFromStorage = useRef(
		getFromSessionStorage<string>(PREVIOUS_URL_KEY)
	)
	return previousUrlFromStorage.current
}
